import concernIcon from "@/src/assets/icons/progress/icon_progressbar_vertrag.svg";
import documentsIcon from "@/src/assets/icons/progress/icon_progressbar_vertrag_upload.svg";
import insuranceIcon from "@/src/assets/icons/progress/icon_progressbar_versicherung.svg";

const progressBarSteps = [
  {
    key: "concern",
    name: "Ihr Arbeitsverhältnis",
    icon: concernIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
  {
    key: "insurance",
    name: "Versicherung",
    icon: insuranceIcon,
  },
];

export default progressBarSteps;
